import { useState } from "react";
import { Lightbulb, Question } from "@phosphor-icons/react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

export const Explainer = ({ id, title = "How this page works", children }) => {
  const key = `celebre_exp_${id}`;
  const [hidden, setHidden] = useState(localStorage.getItem(key) === "1");
  if (hidden) return (
    <button data-testid={`explainer-reopen-${id}`} onClick={() => { localStorage.removeItem(key); setHidden(false); }}
      className="inline-flex items-center gap-1.5 text-[12px] font-medium text-[hsl(9,55%,50%)] hover:text-[hsl(9,60%,38%)] transition-colors">
      <Question size={14} weight="bold" /> What does this page do?
    </button>
  );
  return (
    <div data-testid={`explainer-${id}`} className="flex items-start gap-3 bg-orange-50/70 border border-orange-200/60 rounded-xl px-4 py-3.5">
      <span className="mt-0.5 w-7 h-7 shrink-0 rounded-full bg-[hsl(9,69%,62%)]/10 flex items-center justify-center">
        <Lightbulb size={15} weight="duotone" className="text-[hsl(9,69%,52%)]" />
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-semibold text-[#2F2D2C]">{title}</p>
        <p className="text-[13px] text-[#6E6864] leading-relaxed mt-0.5">{children}</p>
      </div>
      <button data-testid={`explainer-dismiss-${id}`} onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }}
        className="shrink-0 text-[12px] font-semibold text-[hsl(9,55%,48%)] hover:text-[hsl(9,60%,38%)] px-2.5 py-1 rounded-full hover:bg-orange-100/70 transition-colors">
        Got it
      </button>
    </div>
  );
};

export const Jargon = ({ tip, children }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="border-b border-dashed border-[hsl(9,69%,62%)]/50 cursor-help">{children}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[260px] text-[12px] leading-relaxed">{tip}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export const WarmEmptyState = ({ icon: Icon, title, what, cta, ctaTestId, onCta }) => (
  <div className="bg-white border border-orange-100 rounded-2xl py-14 px-8 text-center card-float">
    <div className="mx-auto w-16 h-16 rounded-full bg-orange-50 flex items-center justify-center">
      <Icon size={28} weight="duotone" className="text-[hsl(9,69%,58%)]" />
    </div>
    <p className="font-display font-bold text-lg mt-4">{title}</p>
    <p className="text-[13px] text-[#6E6864] leading-relaxed mt-1.5 max-w-sm mx-auto">{what}</p>
    {cta && (
      <button data-testid={ctaTestId} onClick={onCta}
        className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[hsl(9,69%,62%)] hover:bg-[hsl(8,54%,54%)] text-white text-[13px] font-semibold transition-colors">
        {cta}
      </button>
    )}
  </div>
);
